<template>
  <ValidationProvider v-slot="{ validate, errors }"
                      :vid="vid"
                      :name="name"
                      :rules="rules"
                      tag="div"
                      ref="provider"
  >
    <span>{{ label }}</span>
    <div>
      <slot :loading="loading"
            :fileChooserHandler="fileChooserHandler"
      ></slot>
      <input v-if="isEditMerchant"
             type="file"
             ref="upload"
             :id="id"
             :multiple="multiple"
             :isEditMerchant="isEditMerchant"
             :class="{ hide: hideInput }"
             v-stream:change="onUpdate$"
      >
      <input v-else
             type="file"
             ref="upload"
             :id="id"
             :multiple="multiple"
             :isEditMerchant="isEditMerchant"
             :class="{ hide: hideInput }"
             v-stream:change="onUpload$"
      >
    </div>
    <span v-if="errors" class="file-uploader__error">{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { from } from 'rxjs';
import {
  filter,
  pluck,
  switchMap,
  tap,
  map,
} from 'rxjs/operators';
import http from '../../helpers/http';
import { getErrorMsg } from '../../helpers/error-msg';
import toastSettings from '../../helpers/toast-settings';
import agcFormElementMixin from '../../mixins/agc-form-element';
import { SET_USER } from '../../store';

export default {
  mixins: [agcFormElementMixin],
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    publicApi: {
      type: Boolean,
      default: false,
    },
    hideInput: {
      type: Boolean,
      default: true,
    },
    uploadType: String,
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapGetters(['role']),
    ...mapState(['user']),
    apiUrl() {
      return (this.role === 'admin' || this.role === 'sale') ? `/agc-${this.role}-api/merchants/update` : '/agc-merchant-api/setting/update';
    },
    merchantId() {
      return (this.role === 'admin' || this.role === 'sale') ? this.$route.params.id : this.user.id;
    },
    apiBase() {
      return this.publicApi ? 'public' : this.role;
    },
  },
  domStreams: ['onUpload$', 'onUpdate$'],
  subscriptions() {
    const validate$ = (e) => from(this.$refs.provider.validate(e))
      .pipe(
        filter(({ valid }) => valid),
        map(() => e),
        pluck('target', 'files'),
      );
    const update$ = () => http(
      {
        method: 'POST',
        url: this.apiUrl,
        data: {
          fieldName: this.fieldName,
          value: this.inputVal,
          merchantId: this.merchantId,
        },
      },
      {
        error: ({ data: { msg } }) => {
          this.$bvToast.toast(getErrorMsg(msg), {
            ...toastSettings,
            title: '錯誤',
            toaster: 'b-toaster-top-center',
          });
        },
        complete: () => {
          this.loading = false;
        },
      },
    );

    const upload$ = (files) => {
      let uri;
      const params = {
        type: this.uploadType,
      };
      const data = new FormData();
      if (this.multiple) {
        uri = 'images';
        for (let i = 0; i < files.length; i += 1) {
          data.append('upload[]', files[i]);
        }
      } else {
        uri = 'image';
        data.append('upload', files[0]);
        console.log(this.inputVal);
      }
      return http({
        method: 'POST',
        url: `/agc-${this.apiBase}-api/upload/${uri}`,
        params,
        data,
      }, {
        next: (res) => {
          if (this.fieldName === 'logo') {
            this.user.logo = res;
          }
          if (this.multiple) {
            // if (!this.inputVal) {
            //   this.inputVal = [];
            // }
            this.inputVal = [];
            res.forEach((image) => {
              this.inputVal.push(image);
            });
          } else {
            this.inputVal = res;
          }
        },
        complete: () => {
          this.$store.commit(SET_USER, this.user);
          this.$refs.upload.value = '';
          this.loading = false;
        },
      });
    };

    return {
      upload: this.onUpload$
        .pipe(
          pluck('event'),
          switchMap(validate$),
          tap(() => {
            this.loading = true;
          }),
          switchMap(upload$),
        ),
      update: this.onUpdate$
        .pipe(
          pluck('event'),
          switchMap(validate$),
          tap(() => {
            this.loading = true;
          }),
          switchMap(upload$, update$),
        ),
    };
  },
  methods: {
    fileChooserHandler() {
      this.$refs.upload.click();
    },
  },
};
</script>

<style scoped lang="scss">
input[type=file].hide {
  display: none;
}

.file-uploader__error {
  font-size: 80%;
  color: #dc3545;
}
</style>
